import React, { ReactElement } from 'react';

import SuspenseLoadPage from '../components/Auth/SuspenceLoadPage';

const NominationsCom = React.lazy(() => import('../components/Nominations'));

function Nominations(): ReactElement {
  return (
    <SuspenseLoadPage>
      <NominationsCom />
    </SuspenseLoadPage>
  );
}

export default Nominations;
